const template = {
  namespaced: true,
  state: {
    searchkeys: []
  },

  mutations: {
    SET_SEARCHKEYS: (state, searchkeys) => {
      state.searchkeys = searchkeys;
    }
  },

  actions: {},
  getters: {
    searchkeys: (state) => state.searchkeys
  }
};

export default template;
